import { render, staticRenderFns } from "./PedidoEnDespacho.vue?vue&type=template&id=3c24d096&"
import script from "./PedidoEnDespacho.vue?vue&type=script&lang=js&"
export * from "./PedidoEnDespacho.vue?vue&type=script&lang=js&"
import style0 from "./PedidoEnDespacho.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports